import type {EventSocketMessage} from '@myparcel-frontend/event-service';
import type {events} from '@myparcel-frontend/product-service';
import {matchProductEvent} from '@myparcel-frontend/product-service';
import {useProductStore} from '../../store/productStore/productStore';
import {useProducts} from '../useProducts/useProducts';
import useShop from '../useShop/useShop';

export default function useProductServiceEvents() {
  const {addProduct, upsertProduct, productById} = useProductStore();
  const {indexedProductIds, setRecentlyAddedProductId, setRecentlyUpdatedProductId} = useProducts();
  const {currentShop} = useShop();

  const handleProductCreatedEvent = (data: events.ProductCreatedEventValue): void => {
    const product = data;

    if (product.shopIds && !product.shopIds.includes(currentShop.value.id.toString())) {
      // the product does not belong to the current shop, nothing to do
      return;
    }

    if (productById(product.id)) {
      // the product has already been added to the store, nothing to do
      return;
    }

    addProduct({...product});

    if (!indexedProductIds.value.includes(product.id)) {
      indexedProductIds.value.unshift(product.id);
    }
    setRecentlyAddedProductId(product.id);
  };

  const handleProductUpdatedEvent = (data: events.ProductUpdatedEventValue) => {
    const product = data;

    if (product.shopIds && !product.shopIds.includes(currentShop.value.id.toString())) {
      return;
    }

    upsertProduct({...product});

    if (indexedProductIds.value.includes(product.id)) {
      setRecentlyUpdatedProductId(product.id);
    }
  };

  const handleProductMessage = (event: EventSocketMessage) =>
    matchProductEvent(event, {
      onCreated: handleProductCreatedEvent,
      onUpdated: handleProductUpdatedEvent,
    });

  return {handleProductMessage};
}
